import { Box, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { SectionTitle } from '@scoir/headers'

const useStyles = makeStyles((theme) => ({
  modalSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(1, 3, 3),
  },
}))

interface ISectionProps {
  title: React.ReactNode | string
  children: React.ReactNode
  subTitle?: React.ReactNode | string
}

const Section = ({ children, ...rest }: ISectionProps) => {
  const classes = useStyles()
  return (
    <Paper
      elevation={0}
      className={classes.modalSection}
    >
      <Box mb={-2}>
        <SectionTitle {...rest} />
      </Box>
      {children}
    </Paper>
  )
}

export default Section
